<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
<div class="content" [formGroup]="form">
  <div class="mobile-define-size">
    <div class="content-mobile" #radio_area>
      <div class="radio-content">
        <div class="radio-area" *ngFor="let radio of question.answersOBJ; let i = index">
          <input #radioCheck style="display: none;" type="radio" class="rad-input" name="value" [value]="radio.value" formControlName="value" [attr.id]="'c' + i + question.id_question">
          <label class="radio-data"  [ngStyle]="{'border-color': objColor['background-color']}" [attr.for]="'c' + i + question.id_question">
            <div class="rad-design" [ngStyle]="{'background': objColor['background-color']}"></div>
            <span style="display: flex; width: 100%;">{{radio.value}}</span>
            <div class="card-state-icon" *ngIf="radioCheck.checked" [ngStyle]="{'color': objColor['background-color']}">
              <p class="check"></p>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="button-area">
    <button class="btn-primary" [ngStyle]="objColor" (click)="finishQuestion()">Próximo</button>
  </div>
</div>

